/**
 * Dev Grid Overlay
 * Toggle with Alt+G (Windows/Linux) or Option+G (Mac)
 * Shows column guides matching the site's grid system
 */
class DevGrid extends HTMLElement {
  constructor() {
    super();
    this.isVisible = false;
    this.currentColumns = 0;
  }

  connectedCallback() {
    this.render();
    this.bindKeydown();
    this.bindResize();
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeydown);
    window.removeEventListener('resize', this.handleResize);
  }

  bindKeydown() {
    this.handleKeydown = (e) => {
      // Alt+G (Windows/Linux) or Option+G (Mac)
      if (e.code === 'KeyG' && e.altKey) {
        e.preventDefault();
        this.toggle();
      }
    };
    document.addEventListener('keydown', this.handleKeydown);
  }

  bindResize() {
    this.handleResize = () => {
      const newColumns = this.getColumnCount();
      if (newColumns !== this.currentColumns) {
        this.render();
      }
    };
    window.addEventListener('resize', this.handleResize);
  }

  toggle() {
    this.isVisible = !this.isVisible;
    this.classList.toggle('is-visible', this.isVisible);
  }

  getColumnCount() {
    return parseInt(
      getComputedStyle(document.documentElement)
        .getPropertyValue('--grid-columns')
        .trim() || '4',
      10
    );
  }

  render() {
    this.currentColumns = this.getColumnCount();
    this.innerHTML = `
      <div class="dev-grid__container">
        ${Array.from({ length: this.currentColumns }, () => '<div class="dev-grid__column"></div>').join('')}
      </div>
    `;
  }
}

if (!customElements.get('dev-grid')) {
  customElements.define('dev-grid', DevGrid);
}
